import React, { useState, useEffect } from "react";
import axios from "axios";

export default function Achievement() {
  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(0);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BACKEND_URL + "/api/achievement")
      .then((res) => {
        //console.log("achivements " + res.data);
        setAchievements(res.data);

        if (res.data.length > 0) {
          setLoading(1);
        }
      });
  }, []);

  return (
    <div class="work-experience group">
      <div
        class="heading"
        data-aos="fade-up"
        data-aos-delay="300"
        data-aos-duration="400"
      >
        <h2 class="text-center">Achievements</h2>
      </div>

      {loading == 0 ? (
        <center>
          <div
            class="spinner-border text-primary"
            role="status"
            style={{ marginBottom: "100px" }}
          >
            <span class="sr-only">Loading...</span>
          </div>
        </center>
      ) : (
        achievements.map((achievement) => {
          return (
            <div
              class="item"
              style={{ textAlign: "left" }}
              data-aos="fade-up"
              data-aos-delay="400"
              data-aos-duration="500"
            >
              <div class="row">
                <div class="col-md-8 ">
                  <h3>
                    <svg
                      width="1em"
                      height="1em"
                      viewBox="0 0 16 16"
                      class="bi bi-trophy-fill"
                      fill="#0f55b8"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935zm10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935z"
                      />
                    </svg>
                    &nbsp;
                    {achievement.Title}
                  </h3>
                </div>
              </div>
              <p class="text-muted" style={{ fontWeight: "normal" }}>
                {achievement.Description}
              </p>
            </div>
          );
        })
      )}
    </div>
  );
}
